(function () {
    console.log("Mobile menu code loaded")

    let banner

    const bannerContainer = document.querySelector(".banner-container") 
    const navbar = document.getElementById("navbar")
    const siteLogo = bannerContainer.querySelector(".site-logo")
    const mobileMenuButton = bannerContainer.querySelector(".mobile-menu button")
    const searchMobile = bannerContainer.querySelector(".search-mobile")
    const overlay = bannerContainer.querySelector(".banner-bottom-overlay")
    const topOverlay = bannerContainer.querySelector(".banner-container .banner-top-overlay")

    if (navbar) {
        navbar.addEventListener("show.bs.collapse", function () {
            showMobileMenu();
        })
        navbar.addEventListener("hide.bs.collapse", function () {
            hideMobileMenu();
        })
    }


    function showMobileMenu() {
        banner = bannerContainer.querySelector(".banner")
        if (banner) {
            banner.remove()
            console.log("found banner!", banner)
        }
        if (siteLogo) {
            siteLogo.style.position = "static"
        }
        if (mobileMenuButton) {
            mobileMenuButton.innerHTML = "<img src=\"/img/menuclose.svg\" alt=\"menu close\" width=\"32\ height=\"20\" >"
        }
        if (searchMobile) {
            searchMobile.style.display = "block"
        }
        if (overlay) {
            overlay.style.display = "block"
        }
        if (bannerContainer) {
            bannerContainer.classList.add("mobile")
        }
    }




    function hideMobileMenu() {
        if (banner) {
            topOverlay.after(banner)
        }
        if (navbar) {
            navbar.classList.remove("show")
        }
        if (mobileMenuButton) {
            mobileMenuButton.innerHTML = "<img src=\"/img/menu.svg\" alt=\"menu\" width=\"32\ height=\"20\" >"
        }
        if (searchMobile) {
            searchMobile.style.display = "none"
        }
        if (overlay) {
            overlay.style.display = "none"
        }
        if (bannerContainer) {
            bannerContainer.classList.remove("mobile")
        }
    }

    function viewport() {
        var e = window, a = 'inner';
        if (!('innerWidth' in window)) {
            a = 'client';
            e = document.documentElement || document.body;
        }
        return { width: e[a + 'Width'], height: e[a + 'Height'] };
    }


    let resizeTimer = null
    let currentView = viewport()
    let toplinks = null
    const topNav = bannerContainer.querySelector(".top-nav")

    function handleTopLinks() {
        const view = viewport();
        toplinks = document.querySelector(".banner-container .top-links");
        if (toplinks) {
            if (view.width >= 992) {
                toplinks.remove()
                siteLogo.after(toplinks)
            } else {
                toplinks.remove()
                topNav.after(toplinks)
            }
        }
    }

    function resizeEnd() {
        const view = viewport();
        clearTimeout(resizeTimer);
        hideMobileMenu();
        handleTopLinks();
        if (view.width >= 992) {
            overlay.style.display = "block"
            navbar.classList.remove("collapse")
        }
    }

    function reflow() {
        const prevWidth = currentView.width;
        currentView = viewport();
        if (prevWidth != currentView.width && (document.activeElement.nodeName !== 'INPUT' || currentView.width >= 768)) {
            if (resizeTimer != null) {
                clearTimeout(resizeTimer);
            }
            resizeTimer = setTimeout(resizeEnd, 300);
        }
    }

    window.addEventListener("resize", () => {
        reflow()
    })

    handleTopLinks()

})();
